/* @flow strict */

import * as React from 'react';
import Modal from './../../../components/Modal';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import BtnLoader from '/client/src/components/btns/circularProgress/';
import t from '/client/src/utils/i18nCheckKey';
import i18next from 'i18next';
import { PUT } from '/client/src/api';

import './styles.scss';

type PropsType = {
  isOpen: boolean,
  handleToggleModal: (boolean) => void
};

class EditLanguageModal extends React.Component<PropsType> {
  props: PropsType;

  static contextType = DefaultContainerContext;

  constructor(props: PropsType) {
    super(props);

    this.state = {
      isLocked: false,
      lang: 'en-US'
    };
  }

  componentDidMount() {
    this.setState({
      lang: this.context.profileCurrent.lang
    });
  }

  handleSave = async (setStatus: (string) => void) => {
    const {
      isLocked,
      lang
    } = this.state;

    if (isLocked) {
      return;
    }

    this.setState({
      isLocked: true
    }, () => {
      setStatus('loading');
    });

    try {
      const { success } = await PUT('/api/v1/1/merchants/lang', { lang });

      if (success) {
        this.setState({
          isLocked: false
        }, () => {
          setStatus('success');

          this.context.handleGetProfile();

          this.context.handleShowSystemDialog(true, {
            systemDialogType: 'success',
            systemDialogTitle: 'Great!',
            systemDialogContent: 'Language changed'
          });

          this.handleClose();
        });
      }
    } catch (error) {
      this.setState({
        isLocked: false
      }, () => {
        this.context.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Can\'t change language'
        });

        setStatus('error');
        console.error(error);

        setTimeout(() => {
          setStatus('');
        }, 5000);
      });
    }
  };

  handleClose = (): any => {
    const { handleToggleModal } = this.props;

    handleToggleModal(false);
  };

  handleSelect = (lang: string) => {
    i18next.changeLanguage(lang, () => {
      this.setState({
        lang
      });
    });
  };

  render(): React.Element {
    const { isOpen } = this.props;
    const {
      isLocked,
      lang
    } = this.state;

    return (
      <Modal
        opened={isOpen}
        onClose={this.handleClose}
        ignoreOutsideClick
      >
        <div className="modal-dialog customModal EditLanguageModal" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t('Edit Language')}</h4>
            </div>
            <div className="modal-body" style={{ cursor: isLocked ? 'not-allowed' : 'auto' }}>

              <label htmlFor="#">{t('Language')}</label>

              <ul className="EditLanguageList">
                <li
                  className={`EditLanguageListItem ${lang === 'en-US' ? 'active' : ''}`}
                  onClick={() => {
                    this.handleSelect('en-US');
                  }}
                >
                  <div className="flag flag-us" />
                  <p>English</p>
                </li>

                <li
                  className={`EditLanguageListItem ${lang === 'fr-CA' ? 'active' : ''}`}
                  onClick={() => {
                    this.handleSelect('fr-CA');
                  }}
                >
                  <div className="flag flag-fr" />
                  <p>Français</p>
                </li>

                <li
                  className={`EditLanguageListItem ${lang === 'en-EN' ? 'active' : ''}`}
                  onClick={() => {
                    this.handleSelect('en-EN');
                  }}
                >
                  <div className="flag flag-mxn" />
                  <p>Méjico</p>
                </li>
              </ul>

              <br/>
            </div>

            <div className="modal-footer">
              <button className="btn btn-gray" onClick={this.handleClose}>{t('Close')}</button>
              <span className='custom-pb-container'>
                <BtnLoader
                  label={t('Save')}
                  handleCallBack={(e: SyntheticEvent<HTMLButtonElement>, setStatus: (string) => void) => {
                    this.handleSave(setStatus);
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default EditLanguageModal;
